import { useEffect, useState, createElement } from 'react';
import { debounce } from '../../utils/debounce';
import Carousel from '../carousel/carousel';
import './goods-card-list.scss';
const GoodsCardList = ({ dataList = [], maxSales = 1000, onClick = () => { }, ...otherProps }) => {
    const [positions, setPositions] = useState([]);
    const [columnWidth, setColumnWidth] = useState(0);
    const [maxContainerHeight, setMaxContainerHeight] = useState(0);
    useEffect(() => {
        const updateLayout = () => {
            const container = document.querySelector('.waterfall-container');
            if (container) {
                const itemElements = document.querySelectorAll('.waterfall-item');
                const horizontalGap = 12;
                const verticalGap = 10;
                const containerWidth = container.offsetWidth;
                const calculatedColumnWidth = (containerWidth - horizontalGap) / 2;
                setColumnWidth(calculatedColumnWidth);
                const columnHeights = Array.from({ length: 2 }).fill(0);
                const newPositions = [];
                itemElements.forEach((item) => {
                    const { height } = item.getBoundingClientRect();
                    const minHeight = Math.min(...columnHeights);
                    const columnIndex = columnHeights.indexOf(minHeight);
                    const left = columnIndex * (calculatedColumnWidth + horizontalGap);
                    const top = columnHeights[columnIndex];
                    newPositions.push({ left, top });
                    columnHeights[columnIndex] += height + verticalGap;
                });
                setPositions(newPositions);
                setMaxContainerHeight(Math.max(...columnHeights));
            }
        };
        const debouncedUpdateLayout = dataList.length < 15 ? updateLayout : debounce(updateLayout, 200);
        const handleImageLoad = () => {
            debouncedUpdateLayout();
        };
        debouncedUpdateLayout();
        const images = document.querySelectorAll('.waterfall-container img');
        images.forEach((img) => {
            if (img.complete) {
                handleImageLoad();
            }
            else {
                img.addEventListener('load', handleImageLoad);
            }
        });
        window.addEventListener('resize', debouncedUpdateLayout);
        return () => {
            window.removeEventListener('resize', debouncedUpdateLayout);
            images.forEach((img) => img.removeEventListener('load', handleImageLoad));
        };
    }, [dataList]);
    const resolveResultDesc = (desc) => {
        const htmlString = `<div>${desc}</div>`;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        return tempDiv.textContent || tempDiv.innerText;
    };
    const resultStyle = {
        ...(otherProps.style || {}),
        height: `${maxContainerHeight + 20}px`,
    };
    const _otherProps = {
        ...(otherProps || {}),
        style: resultStyle,
    };
    return (createElement("div", { className: "card-list-goods__container waterfall-container", style: {
            height: `${maxContainerHeight + 20}px`,
        }, ..._otherProps }, dataList.map((item, index) => (createElement("div", { key: item.key, className: "card-list-goods__item waterfall-item", onClick: () => onClick(item), style: {
            left: `${positions[index]?.left}px`,
            top: `${positions[index]?.top}px`,
            width: `${columnWidth}px`,
        } },
        item.imageList && item.imageList.length > 0 && (createElement("div", { className: "card-list-goods__image" },
            createElement(Carousel, { images: item.imageList, interval: 3000 }))),
        createElement("div", { className: "card-list-goods__content" },
            createElement("div", { className: "card-list-goods__title" }, item.title),
            createElement("div", { className: "card-list-goods__desc" }, resolveResultDesc(item.desc)),
            createElement("div", { className: "card-list-goods__bottom" },
                createElement("div", { className: "card-list-goods__unit" }, "\uFFE5"),
                createElement("div", { className: "card-list-goods__price" }, item.activePrice || item.price),
                item.activePrice && createElement("div", { className: "card-list-goods__unit__delete" }, "\uFFE5"),
                item.activePrice && (createElement("div", { className: "card-list-goods__price__delete" }, item.price)),
                createElement("div", { className: "card-list-goods__sales" },
                    "\u5DF2\u552E",
                    item.sales > maxSales ? `${maxSales}+` : item.sales))))))));
};
GoodsCardList.displayName = 'GoodsCardList';
export default GoodsCardList;
